import * as React from "react";
import Loader from "src/js/components/Loader/LoadingSpinner";

const highlightMatches = (
  text: string,
  searchTerm: string,
): React.ReactNode => {
  if (!searchTerm) return text;
  const words = searchTerm.split(/\s+/).filter((w) => w.length > 0);
  if (words.length === 0) return text;
  const escaped = words.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  const pattern = `(${escaped.join("|")})`;
  const parts = text.split(new RegExp(pattern, "gi"));
  const lowerWords = words.map((w) => w.toLowerCase());
  return parts.map((part, i) =>
    part && lowerWords.some((w) => w === part.toLowerCase()) ? (
      <strong key={i}>{part}</strong>
    ) : (
      part
    ),
  );
};

// a single location item in the search results.
const LocationItem: React.FunctionComponent<{
  item: SimpleLocation;
  onClick: (item: SimpleLocation) => void;
  searchTerm: string;
}> = (props) => {
  const location = props.item;
  const [submitting, setSubmitting] = React.useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (submitting) {
      return;
    }
    setSubmitting(true);
    props.onClick(location);
  };

  const title = "Shop for products at " + location.Name;

  return (
    <div className="location-option">
      <button
        type="button"
        className={`hgs-button ${submitting ? "submitting" : ""}`}
        onClick={handleClick}
        title={title}
      >
        {!submitting ? (
          "Select Location"
        ) : (
          <Loader message="Saving Location. . ." fontSize="14px"></Loader>
        )}
      </button>
      <div className="hospital-result">
        <p className="loc-name">
          {highlightMatches(location.Name, props.searchTerm)}
        </p>
        <p className="loc-address">
          {location.StreetAddress}
          <br />
          <span className="loc-city">{location.City}, </span>
          <span className="loc-state">{location.State} </span>
          <span>{location.Zip}</span>
        </p>
      </div>
    </div>
  );
};

// the list of locations used in the search form.
export const LocationResults: React.FunctionComponent<{
  results: Array<SimpleLocation>;
  handleSelect: (item: SimpleLocation) => void;
  searchTerm: string;
}> = (props) => {
  const results = props.results;

  return (
    <div className="location-results">
      {results.map((item: SimpleLocation) => (
        <LocationItem
          onClick={props.handleSelect}
          item={item}
          key={item.ID}
          searchTerm={props.searchTerm}
        />
      ))}
    </div>
  );
};
